module.exports = __webpack_public_path__ + "assets/img/group-logo-7d1b8732.png";